import { Flex } from '@magnetic/flex'
import { Heading } from '@magnetic/heading'
import { DeploymentStatus } from '@/components/deployment-status'
import { DeploymentTagList } from '@/components/deployment-tag-list'
import { DeploymentHistory } from '@/components/deployment-history'
import { formatTimestamp } from '@/lib/protobuf-utils'
import type { Application as ProtoApplication } from '@/lib/generated-types'

type Application = Pick<
  ProtoApplication,
  | 'currentImageTag'
  | 'currentImageDigest'
  | 'lastDeployedAt'
  | 'ecrRepository'
  | 'ecrRepositoryName'
  | 'imageDeploymentStatus'
  | 'imageDeploymentMessage'
  | 'tagTrackingEnabled'
  | 'trackedImageTag'
  | 'trackedImageDigest'
  | 'tagTrackingMode'
>

interface ImageDeploymentSectionProps {
  application: Application
  applicationId: string
}

export function ImageDeploymentSection({
  application,
  applicationId,
}: ImageDeploymentSectionProps) {
  const effectiveEcrRepository = application.ecrRepository || application.ecrRepositoryName

  return (
    <Flex direction="vertical" gap="md">
      <Heading size="section">Image Deployment</Heading>

      <DeploymentStatus
        currentImageTag={application.currentImageTag}
        currentImageDigest={application.currentImageDigest}
        lastDeployedAt={application.lastDeployedAt ? formatTimestamp(application.lastDeployedAt) : undefined}
        ecrRepository={effectiveEcrRepository}
        imageDeploymentStatus={application.imageDeploymentStatus}
        imageDeploymentMessage={application.imageDeploymentMessage}
        tagTrackingEnabled={application.tagTrackingEnabled}
        trackedImageTag={application.trackedImageTag}
        trackedImageDigest={application.trackedImageDigest}
        tagTrackingMode={application.tagTrackingMode}
      />

      <Flex gap="md" wrap>
        <Flex style={{ flex: '1 1 400px' }}>
          <DeploymentTagList
            applicationId={applicationId}
            currentTag={application.currentImageTag}
            trackedTag={application.trackedImageTag}
            trackingEnabled={application.tagTrackingEnabled}
            trackingMode={application.tagTrackingMode}
          />
        </Flex>
        <Flex style={{ flex: '1 1 400px' }}>
          <DeploymentHistory applicationId={applicationId} />
        </Flex>
      </Flex>
    </Flex>
  )
}
